export default __webpack_public_path__ + "static/media/popular3.937241a3.png";